import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { HeaderBannerDto } from '../models/dto/header-banner-dto';
import { headerBannersReceived } from './header-banner-actions';

export interface HeaderBannersState {
    activeHeaderBanners: PaginatedResponse<HeaderBannerDto>;
}

const initialState: HeaderBannersState = {
    activeHeaderBanners: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
};

export const activeHeaderBannersReducer = createReducer(initialState, builder => {
    builder.addCase(headerBannersReceived, (state, action) => ({ ...state, activeHeaderBanners: action.payload }));
});
